/**
 * Full-screen modal for displaying place or event details on mobile
 */

import { Dialog, DialogContent } from '@/components/ui/dialog';
import { PlaceMarkerPopup } from './PlaceMarkerPopup';
import { EventMarkerPopup } from './EventMarkerPopup';
import { VisuallyHidden } from '@/components/ui/visually-hidden';
import { DialogTitle } from '@/components/ui/dialog';

interface GeographicEntityWithRelevance extends GeographicEntity {
    relevanceType?: string;
    relevanceReason?: string;
}

interface EventMarkerData {
    event: HistoricalEventByPassage | HistoricalEvent;
    position: unknown;
    matchingPlace: GeographicEntity;
}

interface MobileEntityModalProps {
    entity: GeographicEntityWithRelevance | null;
    eventMarker: EventMarkerData | null;
    onClose: () => void;
    bookName?: string;
    passageYear?: number | null;
    historicalEvents: HistoricalEvent[];
}

export function MobileEntityModal({
    entity,
    eventMarker,
    onClose,
    bookName,
    passageYear,
    historicalEvents
}: MobileEntityModalProps) {
    const isOpen = !!entity || !!eventMarker;

    return (
        <Dialog open={isOpen} onOpenChange={(open) => !open && onClose()}>
            <DialogContent className="max-w-[100vw] w-full h-[92vh] sm:h-auto sm:max-w-lg p-0 overflow-hidden border-none rounded-t-[2rem] sm:rounded-lg bottom-0 top-auto translate-y-0 data-[state=open]:slide-in-from-bottom duration-300">
                <VisuallyHidden>
                    <DialogTitle>
                        {entity ? `Place Details: ${entity.placeName}` : eventMarker ? `Event Details: ${eventMarker.event.title}` : 'Details'}
                    </DialogTitle>
                </VisuallyHidden>

                <div className="h-full overflow-y-auto p-6 pt-8">
                    {entity && (
                        <PlaceMarkerPopup
                            entity={entity}
                            bookName={bookName}
                            passageYear={passageYear}
                        />
                    )}
                    {eventMarker && (
                        <EventMarkerPopup
                            event={eventMarker.event}
                            historicalEvents={historicalEvents}
                            bookName={bookName}
                            matchingPlace={eventMarker.matchingPlace}
                            passageYear={passageYear}
                        />
                    )}
                </div>
            </DialogContent>
        </Dialog>
    );
}
